import { WildNavigationType } from "../../../../../../data/enums/navigation_type";
import { FeaturesComponentListData } from "../../FeaturesData";

export const openWaterCoachListData: FeaturesComponentListData = {
  image: "https://firebasestorage.googleapis.com/v0/b/wild-live.appspot.com/o/v2%2Fimagesforbrochuresite%2Fopen-water-coach.jpg?alt=media&token=e3557149-8fd8-4a3e-a870-8bb1e64a1497",
  title: "Open Water Coaching",
  subtitle: "Small Business. Big Results.",
  page: WildNavigationType.OPENWATERCOACH,
}